<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Holiday</h5>
            </div>
            <div class="basic-contbox">
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Holiday Name</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Basic usage" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Date</h5>
                    </div>
                    <div class="emp-input">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Department</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Technical Support" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Department</h5>
                    </div>
                    <div class="emp-input">
                        <textarea rows="4" formControlName="comment" nz-input></textarea>
                    </div>
                </div>

            </div>
            <div class="grace-btnbox">
                <ul>
                    <li><a href="javascript:void();"><span></span> Edit</a></li>
                    <li><a href="javascript:void();"><span></span> Save</a></li>
                    <li><a href="javascript:void();"><span></span> Clear</a></li>
                    <li><a href="javascript:void();"><span></span>Close</a></li>
                </ul>
            </div>
        </div>
        <div class="basic-details basic-details3">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Employee List</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Left Company Name</th>
                            <th>Owner</th>
                            <th>Company Bussiness</th>
                            <th>Address</th>
                            <th>Contact No.</th>
                            <th>Worked As</th>
                            <th>Work Duration</th>
                            <th>Reason</th>
                            <th>Remark</th>
                            <th>Del</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>